import { SupabaseLeadRepository } from '../repositories/SupabaseLeadRepository';
import { SupabaseFunnelStageRepository } from '../repositories/SupabaseFunnelStageRepository';
import { SupabaseFunnelRepository } from '../repositories/SupabaseFunnelRepository';
import { SupabaseTaskRepository } from '../repositories/SupabaseTaskRepository';
import { SupabaseUserRepository } from '../repositories/SupabaseUserRepository';

import { CreateLeadUseCase } from '../../application/use-cases/leads/CreateLeadUseCase';
import { UpdateLeadUseCase } from '../../application/use-cases/leads/UpdateLeadUseCase';
import { DeleteLeadUseCase } from '../../application/use-cases/leads/DeleteLeadUseCase';
import { GetLeadsUseCase } from '../../application/use-cases/leads/GetLeadsUseCase';

import { CreateFunnelStageUseCase } from '../../application/use-cases/funnel-stages/CreateFunnelStageUseCase';
import { UpdateFunnelStageUseCase } from '../../application/use-cases/funnel-stages/UpdateFunnelStageUseCase';
import { DeleteFunnelStageUseCase } from '../../application/use-cases/funnel-stages/DeleteFunnelStageUseCase';
import { GetFunnelStagesUseCase } from '../../application/use-cases/funnel-stages/GetFunnelStagesUseCase';

import { GetFunnelsUseCase } from '../../application/use-cases/funnels/GetFunnelsUseCase';
import { CreateFunnelUseCase } from '../../application/use-cases/funnels/CreateFunnelUseCase';
import { UpdateFunnelUseCase } from '../../application/use-cases/funnels/UpdateFunnelUseCase';
import { DeleteFunnelUseCase } from '../../application/use-cases/funnels/DeleteFunnelUseCase';

import { CreateTaskUseCase } from '../../application/use-cases/tasks/CreateTaskUseCase';
import { UpdateTaskUseCase } from '../../application/use-cases/tasks/UpdateTaskUseCase';
import { DeleteTaskUseCase } from '../../application/use-cases/tasks/DeleteTaskUseCase';

import { CreateUserUseCase } from '../../application/use-cases/users/CreateUserUseCase';
import { UpdateUserUseCase } from '../../application/use-cases/users/UpdateUserUseCase';
import { DeleteUserUseCase } from '../../application/use-cases/users/DeleteUserUseCase';

import { WinDealUseCase } from '../../application/use-cases/deals/WinDealUseCase';
import { LoseDealUseCase } from '../../application/use-cases/deals/LoseDealUseCase';
import { ReopenDealUseCase } from '../../application/use-cases/deals/ReopenDealUseCase';

// Repositories (singletons)
const leadRepository = new SupabaseLeadRepository();
const funnelStageRepository = new SupabaseFunnelStageRepository();
const funnelRepository = new SupabaseFunnelRepository();
const taskRepository = new SupabaseTaskRepository();
const userRepository = new SupabaseUserRepository();

// Use Cases - Leads
export const createLeadUseCase = new CreateLeadUseCase(leadRepository);
export const updateLeadUseCase = new UpdateLeadUseCase(leadRepository);
export const deleteLeadUseCase = new DeleteLeadUseCase(leadRepository);
export const getLeadsUseCase = new GetLeadsUseCase(leadRepository);

// Use Cases - Funnel Stages
export const createFunnelStageUseCase = new CreateFunnelStageUseCase(funnelStageRepository);
export const updateFunnelStageUseCase = new UpdateFunnelStageUseCase(funnelStageRepository);
export const deleteFunnelStageUseCase = new DeleteFunnelStageUseCase(funnelStageRepository, leadRepository);
export const getFunnelStagesUseCase = new GetFunnelStagesUseCase(funnelStageRepository);

// Use Cases - Funnels
export const getFunnelsUseCase = new GetFunnelsUseCase(funnelRepository);
export const createFunnelUseCase = new CreateFunnelUseCase(funnelRepository);
export const updateFunnelUseCase = new UpdateFunnelUseCase(funnelRepository);
export const deleteFunnelUseCase = new DeleteFunnelUseCase(funnelRepository, funnelStageRepository, leadRepository);

// Use Cases - Tasks
export const createTaskUseCase = new CreateTaskUseCase(taskRepository);
export const updateTaskUseCase = new UpdateTaskUseCase(taskRepository);
export const deleteTaskUseCase = new DeleteTaskUseCase(taskRepository);

// Use Cases - Users
export const createUserUseCase = new CreateUserUseCase(userRepository);
export const updateUserUseCase = new UpdateUserUseCase(userRepository);
export const deleteUserUseCase = new DeleteUserUseCase(userRepository);

// Use Cases - Deals
export const winDealUseCase = new WinDealUseCase(leadRepository);
export const loseDealUseCase = new LoseDealUseCase(leadRepository);
export const reopenDealUseCase = new ReopenDealUseCase(leadRepository);

// Export repositories if needed directly (avoid if possible, prefer Use Cases)
export const repositories = {
    lead: leadRepository,
    funnelStage: funnelStageRepository,
    funnel: funnelRepository,
    task: taskRepository,
    user: userRepository
};

